import { render, staticRenderFns } from "./underConstruction.vue?vue&type=template&id=43423514"
import script from "./underConstruction.vue?vue&type=script&lang=ts"
export * from "./underConstruction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports